import { EntityRow, ConditionRow } from './CustomInsightsRow';
import { conditions, entity } from './types';
import React, { FC } from 'react';

interface CustomInsightsListProps {
    customInsights: (conditions | entity)[];
    onEdit?: (insight: conditions) => void;
    onDelete?: (insight: conditions | entity) => void;
}

const CustomInsightsList: FC<CustomInsightsListProps> = React.memo(({ customInsights, onEdit, onDelete }) => {
    const resourcesRows = Object.values(customInsights).map((insight: conditions | entity) => {
        if ('type' in insight) {
            return (
                <EntityRow
                    type={insight?.type}
                    key={`user${insight.guid}`}
                    guid={insight.guid}
                    name={insight.name}
                    domainName={insight.domain_name}
                    onDelete={onDelete ? () => onDelete(insight) : undefined}
                />
            );
        }
        return (
            <ConditionRow
                onEdit={onEdit ? () => onEdit(insight) : undefined}
                key={`Condition${insight.conditionString + insight.conditionType}`}
                onDelete={onDelete ? () => onDelete(insight) : undefined}
                condition={insight}
            />
        );
    });

    return (
        <div className="w-full h-full flex flex-col">
            <div className="flex-1 w-full h-full overflow-y-auto no-scrollbar">{resourcesRows}</div>
        </div>
    );
});

export default CustomInsightsList;
